import api from "./api";

export const executionService = {
	// Get all executions
	getExecutions: async (params = {}) => {
		const response = await api.get("/executions", { params });
		return response.data;
	},

	// Get single execution
	getExecution: async (id) => {
		const response = await api.get(`/executions/${id}`);
		return response.data;
	},

	// Get latest execution for a test
	getLatestExecution: async (testId) => {
		const response = await api.get(`/executions/test/${testId}/latest`);
		return response.data;
	},

	// A suite run's stability: each test's tag (New failure, Fixed, Flaky, Always failing,
	// Slow) and recent results, plus counts
	getSuiteRunStability: async (suiteExecutionId) => {
		const response = await api.get(`/suites/executions/${suiteExecutionId}/stability`);
		return response.data;
	},

	// A failed run's analysis (summary + recommended changes to the test), or
	// null when it has none (yet)
	getAnalysis: async (id) => {
		const response = await api.get(`/executions/${id}/analysis`);
		return response.status === 204 ? null : response.data;
	},

	// Analyse a failed run again; answers PENDING, poll getAnalysis
	requestAnalysis: async (id) => {
		const response = await api.post(`/executions/${id}/analysis`);
		return response.data;
	},

	// Change the test as recommended / drop the recommendation. Return the analysis.
	applyRecommendation: async (id, recommendationId) => {
		const response = await api.post(
			`/executions/${id}/analysis/recommendations/${recommendationId}/apply`,
		);
		return response.data;
	},

	dismissRecommendation: async (id, recommendationId) => {
		const response = await api.post(
			`/executions/${id}/analysis/recommendations/${recommendationId}/dismiss`,
		);
		return response.data;
	},

	// Stop a running/pending execution. Returns the execution, now CANCELLED.
	stopExecution: async (id) => {
		const response = await api.post(`/executions/${id}/cancel`);
		return response.data;
	},
};

export default executionService;
